import { LoanTerms } from '../../common/types';
import { MonthlyPaymentState } from '../types';

export function setHomePrice(state: MonthlyPaymentState, payload: number): MonthlyPaymentState {
  return {
    ...state,
    homePrice: payload,
    downPaymentPercent: (state.downPayment / payload) * 100
  };
}

export function setDownPayment(state: MonthlyPaymentState, payload: number): MonthlyPaymentState {
  return {
    ...state,
    downPayment: payload,
    downPaymentPercent: (payload / state.homePrice) * 100
  };
}

export function setDownPaymentPercent(
  state: MonthlyPaymentState,
  payload: number
): MonthlyPaymentState {
  return {
    ...state,
    downPaymentPercent: payload,
    downPayment: state.homePrice * (payload / 100)
  };
}

export function setLoanTerm(state: MonthlyPaymentState, payload: LoanTerms): MonthlyPaymentState {
  return {
    ...state,
    loanTerm: payload
  };
}

export function setInterestRate(state: MonthlyPaymentState, payload: number): MonthlyPaymentState {
  return {
    ...state,
    interestRate: payload
  };
}

export function setPropertyTaxAnnual(
  state: MonthlyPaymentState,
  payload: number
): MonthlyPaymentState {
  return {
    ...state,
    propertyTaxAnnual: payload
  };
}

export function setHomeownersInsuranceMonthly(
  state: MonthlyPaymentState,
  payload: number
): MonthlyPaymentState {
  return {
    ...state,
    homeownersInsuranceMonthly: payload
  };
}

export function setHoaFeesMonthly(
  state: MonthlyPaymentState,
  payload: number
): MonthlyPaymentState {
  return {
    ...state,
    hoaFeesMonthly: payload
  };
}

export function setShowFull(state: MonthlyPaymentState, payload: boolean): MonthlyPaymentState {
  return {
    ...state,
    showFull: payload
  };
}

export function setDefaults(
  state: MonthlyPaymentState,
  initialState: MonthlyPaymentState
): MonthlyPaymentState {
  return {
    ...initialState,
    showFull: true
  };
}
